import * as React from 'react';
import { connect } from 'react-redux';
import { logout } from '../../redux/actions/auth';

interface Props {
  auth: any;
  dispatch: Function;
}

class Route extends React.Component<Props> {
  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.dispatch(logout());
      window.location.href = '/';
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Route);
